class ElementDrawer{
	/**
		data: {
			parent: {
				name: 'parent',
				value: 'parent',
				checked: true,
			},
			children: [data],
		}
	*/
	boxContainer = document.createElement('div');
	data = {
		parent: {},
		children: []
	}
	constructor(data){
		this.wrapper = document.createElement('div');
		this.wrapper.classList.add('element-drawer-wrapper');

		// create the element
		this.element = document.createElement('div');
		this.element.classList.add('element-drawer');

		this.boxContainer.classList.add('drawer-content','animate__animated', 'animate__fadeInLeft', 'hidden');

		const parentLabel = this.createLabel(data.parent, true)
		parentLabel.classList.add('parent-label');
		this.element.appendChild(parentLabel);
		this.data.parent = {
			element: parentLabel,
			data: data.parent
		};
		this.element.setAttribute('data-parent-value', data.parent.value)

		this.element.appendChild(document.createElement('hr'))

		data.children?.forEach(childData => {
			let element = this.createLabel(childData)
			this.boxContainer.appendChild(element);
			this.data.children.push({element: element,data: childData});
		});

		this.element.appendChild(this.boxContainer);

		// now add the opening and closing button
		const toggleDrawerButton = document.createElement('button');
		toggleDrawerButton.type = 'button';
		toggleDrawerButton.classList.add('btn', 'btn-round');
		toggleDrawerButton.innerHTML = `<span class="material-symbols-rounded">expand_more</span>`
		
		toggleDrawerButton.addEventListener('click', () => {
			this.boxContainer.classList.toggle('hidden');
			toggleDrawerButton.querySelector('span').innerHTML = this.boxContainer.classList.contains('hidden') ? 'expand_more' : 'expand_less';
		})

		this.wrapper.appendChild(this.element); 
		if (data.children && data.children.length > 0)
			this.wrapper.appendChild(toggleDrawerButton);

		// bind methods
		this.wrapper.getData = () => this.data;

		return this.wrapper
	}

	createLabel(data, isParent = false){
		const container = document.createElement('label');
		
		const p = document.createElement('p');
		p.innerText = data.name;

		const checkbox = document.createElement('input');
		checkbox.type = 'checkbox';
		checkbox.checked = data.checked;
		checkbox.value = data.value;
		
		container.appendChild(checkbox);
		container.appendChild(p);

		checkbox.addEventListener('change', () => {
			data.checked = checkbox.checked;
			if(isParent){
				// now change the children
				this.data.children.forEach(child => {
					child.element.querySelector('input[type="checkbox"]').checked = checkbox.checked;
				})
			}
		})

		return container;
	}
}

class ElementBox {
	// data : [data]
	data = []
	constructor(data){
		this.element = document.createElement('div');
		this.element.classList.add('element-box');
		// bind methods
		this.addDrawer = this.addDrawer.bind(this);
		this.initialize = this.initialize.bind(this); 

		// bind to element
		this.element.addDrawer = this.addDrawer;
		this.element.removeDrawer = this.removeDrawer;
		this.element.initialize = this.initialize;
		this.element.getData = () => this.data;

		this.initialize(data)
		
		return this.element
	}

	initialize(data){
		this.data = []
		data?.forEach(dataPoint => {
			this.addDrawer(dataPoint);
		})
	}
	

	addDrawer(dataPoint){
		const drawer = new ElementDrawer(dataPoint)
		this.element.appendChild(drawer);
		this.data.push(drawer.getData());
	}

	removeDrawer(index){
		this.element.removeChild(this.element.children[index]);
		this.data.splice(index, 1);
	}
}
export default ElementBox;